export const PAY_TYPE = {
  PAYMENT: 0,
  PAYOUT: 2,
};

export const PAY_METHOD = {
  BANK_CARD_1: 1,
  PLUS24_2: 2,
  BANK_CARD_3: 3,
  TERMINAL: 4,
  WEB_MONEY: 6,
  PLUS24_7: 7,
  QIWI: 7,
  BANK_CARD_9: 9,
  MOBILE: 10,
  GOOGLE_PAY: 15,
  APPLE_PAY: 16,
};

export const PAY_METHOD_WITH_TYPE = {
  [PAY_TYPE.PAYMENT]: {
    BANK_CARD_1: PAY_METHOD.BANK_CARD_1,
    PLUS24_2: PAY_METHOD.PLUS24_2,
    TERMINAL: PAY_METHOD.TERMINAL,
    WEB_MONEY: PAY_METHOD.WEB_MONEY,
    QIWI: PAY_METHOD.QIWI,
    BANK_CARD_9: PAY_METHOD.BANK_CARD_9,
    MOBILE: PAY_METHOD.MOBILE,
    GOOGLE_PAY: PAY_METHOD.GOOGLE_PAY,
  },
  [PAY_TYPE.PAYOUT]: {
    BANK_CARD_1: PAY_METHOD.BANK_CARD_1,
    BANK_CARD_3: PAY_METHOD.BANK_CARD_3,
    PLUS24_7: PAY_METHOD.PLUS24_7,
    MOBILE: PAY_METHOD.MOBILE,
    GOOGLE_PAY: PAY_METHOD.GOOGLE_PAY,
  },
};

export const ONLY_BANK_CARD_LIST = [
  PAY_METHOD.BANK_CARD_1,
  PAY_METHOD.BANK_CARD_3,
  PAY_METHOD.BANK_CARD_9,
];

export enum PaymentStatus {
  WAIT_PAYMENT = 1, // Ожидание платежа 1
  WAIT_PROCESSING = 11,
  WAIT_PAYMENT_CONFIRM = 12,
  WAIT_EXTERNAL_PAYSYSTEM = 13,
  HOLDED = 14,
  WAIT_AMOUNT_CONFIRM = 15,
  PAYMENT_SUCCESS = 2 /* Успешно 2 */,
  PAYMENT_REFUND = 21,
  PAYMENT_CANCEL = 22,

  // Платёж в ошибке
  PAYMENT_FAILED = 3,
  RETRYABLE_FAILED = 31,
  PAYMENT_TIMEOUT = 32,
  ANTIFROD_DECLINED = 33,

  // Платёж не найден
  PAYMENT_NOTFOUND = 4,

  // Ошибки внутренние
  INTERNAL_ERROR = 5,
  INCORRECT_DATA = 51,

  // Ошибки инвойсов
  INVOICE_DISABLED = 6,

  // Ошибки мерчанта
  MERCHANT_BLOCKED = 7,
}

export const InvoiceSteps = {
  ENTER_AMOUNT: 1,
  ENTER_CARD: 2,
};

export const ErrorStatuses = [
  PaymentStatus.INTERNAL_ERROR,
  PaymentStatus.INCORRECT_DATA,
  PaymentStatus.INVOICE_DISABLED,
  PaymentStatus.PAYMENT_FAILED,
  PaymentStatus.ANTIFROD_DECLINED,
  PaymentStatus.RETRYABLE_FAILED,
];

export const PaymentErrors = {
  'Платеж отклонен': 'errors.4000',
  'Ошибка проведения 3DSecure': 'errors.4001',
  'Транзакция отклонена МПС': 'errors.4002',
  'Ошибка связи с банком': 'errors.4003',
  'Транзакция отклонена банком, выпустившим карту': 'errors.4004',
  'Некорректная сумма платежа': 'errors.4005',
  'Неверно указан номер банковской карты': 'errors.4006',
  'Срок действия карты истёк': 'errors.4007',
  'Карта заблокирована': 'errors.4008',
  'Недостаточно средств для проведения операции': 'errors.4009',
  'Транзакция запрещена банком, выпустившим карту': 'errors.4010',
  'Неверно указан код подтверждения': 'errors.4011',
  'Превышен лимит по сумме транзакции': 'errors.4012',
  'Кошелек пользователя неидентифицирован': 'errors.4013',
  'Платежный аккаунт не найден': 'errors.4014',
  'Отсутствуют карточные данные': 'errors.4015',
  'Не заполнены данные для оплаты': 'errors.4016',
  'Не найдена транзакция': 'errors.4102',
  'Не найдены данные заказа (ориг. транзакции)': 'errors.4103',
  'Невозможно обработать транзакцию указанного типа': 'errors.4104',
  'Ошибка связи с внешней системой': 'errors.4300',
  'Отсутствуют данные запроса в банк': 'errors.4302',
  'Отсутствует SessionCode у платежа': 'errors.4303',
  'Отмена невозможна': 'errors.4401',
  'Ошибка проведения процедуры Reverse/Refund': 'errors.4402',
  'Внутренняя ошибка системы': 'errors.5000',
  'Не удалось сформировать InvoiceID': 'errors.5002',
  'Не удалось заблокировать денежные средства': 'errors.5003',
  'Обнаружена подозрительная активность': 'errors.5005',
  'Не удалось подготовить банковскую карту': 'errors.5101',
  'Оплата с карт Kaspi временно недоступна. Попробуйте оплатить другой картой.': 'errors.5102',
  'Не удалось получить настройки из данных эквайринга': 'errors.5201',
  'Не удалось получить эквайринг': 'errors.5202',
  'Ошибка получения данных о комиссии': 'errors.5301',
  'Отсутствует orderID запроса': 'errors.5303',
  'Ошибка создания заказа на платеж': 'errors.5304',
  'Ошибок нет, транзакция успешна или обрабатывается': 'errors.-1000',
} as const;
